import React, { useState } from "react";
import NavBar from "../../../nav-bar";
import MainNav from "./nav-contents/MainNav";

function Nav() {
  const [triggerClose, setTriggerClose] = useState(false);

  const closeHamburgerMenu = () => {
    setTriggerClose(true);
    // Reset triggerClose state if needed
    // setTimeout(() => {
    //   setTriggerClose(false);
    // }, 10);
  };

  return (
    <NavBar mobileBreakPoint={991} triggerHamburgerClose={triggerClose}>
      <MainNav closeHamburgerMenu={closeHamburgerMenu} />
    </NavBar>
  );
}

export default Nav;
